'use client';
import Typography from '@/components/shared/typography/typography.component';
import { useTranslation } from '@/hook';
import classes from './styles.module.scss';

const ColoredTag = ({
    text,
    tagClicked,
}: {
    text: string | number;
    tagClicked: (text: string | number) => void;
}) => {
    const { t, IS_RTL } = useTranslation();
    return (
        <div onClick={() => tagClicked(text)} className={classes.container}>
            <Typography
                style={IS_RTL ? { marginLeft: '4px' } : { marginRight: '4px' }}
                className={classes.container__text}
                variant={'body2Medium'}
            >
                {/*
            @eslint-disable-next-line @typescript-eslint/ban-ts-comment
          @ts-ignore */}
                {t(text)}
            </Typography>
            <Typography
                variant={'body2Medium'}
                className={classes.container__text}
            >
                x
            </Typography>
        </div>
    );
};

export default ColoredTag;
